import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash';
import styles from './index.module.scss';

import JoboxIcon from '../../icons/jobox.svg';
import YelpIcon from '../../icons/yelp.svg';
import StarIcon from '../../icons/star.svg';

const ReviewItem = ({
  text, rating, url, user, momentObject, isJobox
}) => {
  const [collapsed, setCollapsed] = useState(isJobox);
  const renderHeader = () => (
    isJobox ? (
      <>
        <JoboxIcon />
        <span>Jobox Review</span>
      </>
    ) : (
      <>
        <YelpIcon />
        <span>Yelp Review</span>
      </>
    )
  );

  const textTrimmed = text.length > 150 ? `${text.substring(0, 150)}...` : text;

  const handleExpand = () => {
    setCollapsed(false);
  };

  return (
    <div>
      <div className={styles.heading}>
        <div className={styles.icon}>
          {renderHeader()}
        </div>
        <div className={styles.stars}>
          {times(5, (i) => (
            <div key={i} className={i >= rating ? styles.greyStar : null}>
              <StarIcon />
            </div>
          ))}
        </div>
      </div>
      <span className={styles.text}>{textTrimmed.endsWith('...') && collapsed ? textTrimmed.substring(0, textTrimmed.length - 3) : text}</span>
      {isJobox
        ? <span onClick={handleExpand} className={styles.link}>{collapsed && textTrimmed.endsWith('...') ? 'Read more...' : ''}</span>
        : <a href={url} target="_blank" className={styles.link} rel="noreferrer">Read&nbsp;more...</a>}
      <div className={styles.footer}>
        {!isJobox
          && (
            <>
              <span>{user && user.name}</span>
              <span>|</span>
            </>
          )}
        <span>{momentObject.format('MM/DD/YYYY h:mma')}</span>
      </div>
    </div>
  );
};

ReviewItem.propTypes = {
  rating: PropTypes.number,
  text: PropTypes.string,
  url: PropTypes.string,
  user: PropTypes.shape({
    name: PropTypes.string,
  }),
  momentObject: PropTypes.object,
  isJobox: PropTypes.bool,
};

export default ReviewItem;
